// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"CollaboratorsPage_pageContainer__1kidl","invitationPending":"CollaboratorsPage_invitationPending__nRM1e","resendBtn":"CollaboratorsPage_resendBtn__yzcqQ"};